import { Injectable, inject } from '@angular/core';
import { State, StateContext, Action, Selector } from '@ngxs/store';
import { patch, insertItem } from '@ngxs/store/operators';
import { LandingActions } from './landing.actions';
import { GenericService } from 'src/app/services/generic.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@State<any>({
	name: 'LandingState',
	defaults: {
		featureCareers: [],
		newestListings: [],
		popuplarCategories: []
	}
})
@Injectable()
export class LandingState {
	private genericService = inject(GenericService);
	private ngxLoader = inject(NgxUiLoaderService);


	@Selector()
	static getLandingData(state: any) {
		return state;
	}

	@Action(LandingActions.GetHotJobList)
	getHotJobList(
		context: StateContext<any>,
		action: LandingActions.GetHotJobList
	) {
		this.genericService
			.post('Applicant/GetHotJobList', action.payload)
			.subscribe((data: any) => {
				if (
					data.featuredCareers?.length === 0 &&
					action.payload.value !== 'Philippines'
				) {
					this.genericService
						.post('Applicant/GetHotJobList', { value: 'Philippines' })
						.subscribe((data: any) => {
							context.setState(
								patch<any>({
									featureCareers: data.featuredCareers,
									newestListings: data.newestList
								})
							);
						});
				} else {
					context.setState(
						patch<any>({
							featureCareers: data.featuredCareers,
							newestListings: data.newestList
						})
					);
				}
			});
	}

	@Action(LandingActions.GetTopCategory)
	getTopCategory(context: StateContext<any>) {
		this.genericService
			.get('Applicant/GetTopCategoryJobList')
			.subscribe((data: any) => {
				context.setState(
					patch<any>({
						popuplarCategories: data
					})
				);
			});
	}
}
